<!--采购订单详情页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" style="width: 850px;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="print-table">
        <tr class="noborder">
          <td align="right">订单号：</td>
          <td>{{controlData.erpserial}}</td>
          <td align="right">时&nbsp;&nbsp;&nbsp;&nbsp;间：</td>
          <td>{{controlData.adddate}}</td>
          <td align="right">入库：</td>
          <td>
            {{controlData.cangkuname}}
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">供应商：</td>
          <td width="140">{{controlData.pcustomer||""}}</td>
          <td align="right" width="80">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</td>
          <td width="200">{{controlData.caddress||""}}</td>
          <td align="right" width="80">联系人:</td>
          <td width="140">{{(controlData.clinkman||"")+" " +(controlData.clinkmantel||"")}}</td>
        </tr>
        <!--<tr class="noborder">-->
        <!--<td align="right">收货方：</td>-->
        <!--<td width="140">{{controlData.servedname||""}}</td>-->
        <!--<td align="right">收货地址：</td>-->
        <!--<td width="220">{{controlData.address||""}}</td>-->
        <!--<td align="right">联系人：</td>-->
        <!--<td width="140">{{(controlData.linkman||"")+" " +(controlData.linkmantel||"")}}</td>-->
        <!--</tr>-->
        <!--<tr class="noborder" v-show="isshowqr">-->
          <!--<td align="right">商品条码：</td>-->
          <!--<td width="140">-->
            <!--<el-input v-model="goodsbarcode" size="mini" @change="selectbarcode" ref="goodsbarcode"></el-input>-->
          <!--</td>-->
          <!--&lt;!&ndash;<td align="right"> 库存条码：</td>&ndash;&gt;-->
          <!--&lt;!&ndash;<td width="220">&ndash;&gt;-->
          <!--&lt;!&ndash;<el-input v-model="storegoodsbarcode" size="mini" ref="storegoodsbarcode" @change="stockbarcode"></el-input>&ndash;&gt;-->
          <!--&lt;!&ndash;</td>&ndash;&gt;-->
          <!--<td align="right"></td>-->
          <!--<td></td>-->
          <!--<td align="right"></td>-->
          <!--<td ></td>-->
        <!--</tr>-->
        <tr class="noborder" v-show="!isshowqr">
          <td align="right">跟踪号：</td>
          <td>{{controlData.logisticstracknum||""}}</td>
          <td align="right">供应号：</td>
          <td>
            <a @click="showSupplyOrder()" style="cursor: pointer;color: dodgerblue" v-if="FastCheck">{{controlData.tracknum}}</a>
            <a v-else>{{controlData.tracknum}}</a>
          </td>
          <td align="right">到货日期：</td>
          <td>{{controlData.handleoverdate}}</td>
        </tr>
        <tr class="noborder" v-show="isshowqr">
          <!--<td align="right">跟踪号：</td>-->
          <!--<td width="140">-->
            <!--<el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请输入跟踪单号" onfocus="this.select()"></el-input>-->
          <!--</td>-->
          <td align="right">供应号：</td>
          <td width="220">
            <a @click="showSupplyOrder()" style="cursor: pointer;color: dodgerblue" v-if="FastCheck">{{controlData.tracknum}}</a>
            <el-input v-else v-model="tracknum" size="mini" ref="tracknum" placeholder="请输入供应商单号"
                      onfocus="this.select()"></el-input>
          </td>
          <td>
            <el-button type="primary" size='mini' @click="adjust" v-if="isshowqr&&(caiGouRukuData.length>0)">调整订单数量</el-button>
          </td>
          <td v-if="noscancode">
            <el-button type="warning" size='mini' v-on:click="productimport($event)">导入</el-button>
            <a href="./static/file/采购单唯一码模板.xls" download="C:/Users/Public">下载模板</a>
            <input type="file" ref="fileupload" style="display: none;" @change="change1($event)"/>
          </td>
        </tr>
        <tr class="noborder" v-if="saleorder.returnerpserial"
            @click="lookTuihuo()">
          <td align="right">退货单：</td>
          <td width="140">{{saleorder.returnerpserial}}</td>
        </tr>
      </table>
      <table v-for="(obj,indextable) in this.tableData" style="border-collapse:collapse;width:100%;margin-top: 20px">
        <tr class="noborder" v-show="showtablehead">
          <td align="left" width="90">关联单号：</td>
          <td align="left" width="140" style="font-weight:bold;cursor:pointer"
              @click="lookDetails()">{{saleorder.erpserial}}
          </td>
          <td align="left" width="90" v-if="saleorder.htqd">下单日期：</td>
          <td align="left" width="120">{{saleorder.htqd}}</td>
          <td align="right">数量合计：{{controlData.sumnumber}}</td>
          <!--<td align="left" width="80">应交付日期：</td>-->
          <!--<td align="left">{{obj.jhjgrq}}</td>-->
        </tr>
        <tr>
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;fontSize:'18px'" class="query-table">
              <tr>
                <td
                  v-if="item !='seedcode' && item !='unitguid'&& item !='packagesize'&&item!='bcode'&&((isprint&&item!='总价'&&item!='单价'&&item!='零售价')||!isprint)&&((roletype=='store'&&item!='总价'&&item!='单价')||roletype!='store')"
                  style="text-align: center" v-for="item in obj['column']">
                  {{item}}
                </td>
              </tr>
              <tr v-for="(item,index) in obj['billmap']" style="cursor:pointer;" @click="showDetail(item,0,obj)">
                <td
                  :style="{textAlign:ob['产品名称']||ob['型号']||ob['规格']?'left':'center',minWidth:ob['产品名称']?'150px':''}"
                  v-for="(ob,index) in item"
                  v-if="index!=0&&typeof(ob['packagesize'])=='undefined'&&index!=(item.length-1)&&((isprint&&typeof(ob['总价'])=='undefined'&&typeof(ob['单价'])=='undefined'&&typeof(ob['零售价'])=='undefined')||!isprint)&&((roletype=='store'&&typeof(ob['总价'])=='undefined'&&typeof(ob['单价'])=='undefined')||roletype!='store')">
                  <span v-for="(value,i) in ob" v-if="index!=0">{{i == "单价" || i == "总价" ? parseFloat(value || 0).toFixed(3) : value}}
                    <span style="color: red">{{i == "数量"?(item[item.length - 1]['bcode']==undefined||item[item.length - 1]['bcode']==0?'':'/'+item[item.length - 1]['bcode']):""}}</span></span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td width="70">说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5" style="text-align: left">
            <div v-html="getLiuYan(obj.remark)"></div>
          </td>
        </tr>
        <tr v-if="todoList.length>0">
          <td colspan="6" style="text-align: left">
            <el-table :data="todoList" size="mini" stripe border style="width: 100%;">
              <el-table-column
                label="提交人"
                align="left"
                header-align="center"
                width="70">
                <template slot-scope="scope">
                  {{scope.row.senduname}}
                </template>
              </el-table-column>
              <el-table-column
                align="left"
                label="提交时间" width="140">
                <template slot-scope="scope">
                  {{scope.row.createdate}}
                </template>
              </el-table-column>
              <el-table-column
                label="审核人"
                align="left"
                header-align="center"
                width="70">
                <template slot-scope="scope">
                  {{scope.row.opuname}}
                </template>
              </el-table-column>
              <el-table-column
                align="left"
                label="审核时间" width="140">
                <template slot-scope="scope">
                  {{scope.row.hddate}}
                </template>
              </el-table-column>
              <el-table-column
                label="审核意见"
                align="left"
                header-align="center"
                width="360">
                <template slot-scope="scope">
                  {{scope.row.optype}}  {{scope.row.op}}
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6" style="border:none">
            <table>
              <tr v-for="item in obj['formpropertyData']">
                <td align="left" style="padding-left: 0px;padding-right: 0px;" width="160"
                    v-for="(item2,index) in item">
                  <span style="width:80px;display: inline-block;text-align: right">{{index+"："}}</span>
                  <span style="width:70px;display: inline-block;text-align: left">{{item2}}</span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr v-if="indextable !=tableData.length-1">
          <td colspan="6">
            <div id=content style="border:1px dashed #334455;width: 100%;"></div>
          </td>
        </tr>
      </table>
      <table style="border-collapse:collapse;width:100%;margin-top: 20px">
        <tr class="noborder">
          <td colspan="2">入库人员：{{controlData.handleoveruname}}</td>
          <td colspan="2">制单人员：{{controlData.uname}}</td>
        </tr>
        <tr class="noborder" v-if="batchnoList">
          <td colspan="2">验收人员：{{controlData.handleoveruname}}</td>
          <td colspan="2">验收结论：<el-input v-if="isshowqr"  size="mini" ref="yanshouJiel" v-model="yanshoujiel" style="width: 150px"></el-input><span v-else>验收合格</span></td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="close" size="mini">取 消</el-button>
      <el-button @click="inputBatch" type="success" v-if="batchnoList" plain :disabled="isDisable">批次号</el-button>
      <el-button @click="printBarcode('ewm')" size="mini" icon="el-icon-menu" v-if="barcodeList&&barcodeList.length>0">打印二维码</el-button>
      <el-button @click="createBarcode('ewm')" size="small" icon="el-icon-menu"  :disabled="isDisable" v-else-if="controlData.isdistribute==80">打印二维码</el-button>
      <el-button @click="printBarcode('')" size="mini" icon="el-icon-s-data" v-if="barcodeList&&barcodeList.length>0">打印条码</el-button>
      <el-button @click="createBarcode('')" size="small" icon="el-icon-s-data"  :disabled="isDisable" v-else-if="controlData.isdistribute==80">打印条码</el-button>
      <el-button @click="print1" icon="el-icon-printer" size="mini">打印订单</el-button>
      <el-button type="primary" @click="fastCheckIn" v-if="FastCheck&&isshowqr&&controlData.isdistribute==80&&controlData.status!=820">核对并入库</el-button>
      <template v-else>
      <el-button type="success" size="mini" plain  @click="fastCheckIn" v-if="FastCheck&&isshowqr&&controlData.status!=820">核对供应商数量</el-button>
      <el-button type="primary" @click="update" v-show="isshowqr&&controlData.status!=820" :disabled="isDisable">确认入库</el-button>
      </template>
      <el-button type="primary" v-if="showedit&&!FastCheck&&!showtablehead&&(controlData.needaudit!=9)&&controlData.status!=820" @click="showDetail(tableData[0]['billmap'][0],1)">修改</el-button>
      <span @click="handleloglook" style="position: absolute;bottom: 25px;right: 10px">(处理日志)</span>
      <el-button type="text" @click="exportExcel" size="mini">导出</el-button>
      <el-button type="text" v-if="status=='810'" size="mini" @click="exportExceltable">导出二维表</el-button>
    </div>
    <BuyOrderEditSeedDetail ref="seeddetail" @bindGrid="initData"></BuyOrderEditSeedDetail>
    <HandlelogList ref="HandlelogList"></HandlelogList>
    <StorageBadDetail ref="StorageBadDetail"></StorageBadDetail>
    <StorageBadOut ref="StorageBadOut"></StorageBadOut>
    <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
    <CstagreementEdit ref="DataContactEdit"></CstagreementEdit>
    <BuyfromList ref="BuyfromList"></BuyfromList>
    <BuyfromFastCheck ref="BuyfromFastCheck" @afterCheckIn="afterCheckIn"></BuyfromFastCheck>
    <BuyfromFastCheckFrame ref="BuyfromFastCheckFrame" @afterCheckIn="afterCheckIn"></BuyfromFastCheckFrame>
    <!--<ScanCode ref="ScanCode" @scancodeedit="scancodeedit" @clearscancode="clearscancode"></ScanCode>-->
    <ScanCodeBatch ref="ScanCodeBatch" @scancodeedit="scancodeloadBatch" @clearscancode="scancodeloadBatch"></ScanCodeBatch>
  </el-dialog>
</template>

<script>
  import {printingbuy} from '@/api/set/csagreement';
  import {bardetail} from '@/api/set/jxcgoodsbarcode';
  import {batchSave} from '@/api/set/jxcstoregoodsbarcode';
  import {getRemark} from '@/plugin/ordercommon';
  import {exportExcel,barcodePrint} from '@/api/file'
  import HandlelogList from '@/components/testorder/cstagreement/HandlelogList'
  import {
    getCstagreementListDataNew,
    cstagreementDeleteData,
    cstagreementUpdateData,
    buyodersave, jxcstorelist,
    updatebuyorder, adjustNumber
  } from '@/api/set/csagreement';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import BuyOrderEditSeedDetail from './BuyOrderEditSeedDetail'
  import StorageBadDetail from '@/components/warehouse/StorageBadDetail'
  import {saveData, getListData} from '@/api/set/handlelog';
  import {getDetail} from '@/api/set/jxcgooddetail';
  import StorageBadOut from '@/components/warehouse/StorageBadOut'
  import BaoSunDetail from '@/components/testorder/cstagreement/BaoSunDetail';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  // import ScanCode from '@/components/testorder/cstagreement/ScanCode';
  import ScanCodeBatch from '@/components/testorder/cstagreement/ScanCodeBatch';
  import BuyfromList from '@/components/testorder/buyagreement/BuyfromList'
  import BuyfromFastCheck from '@/components/testorder/buyagreement/BuyfromFastCheck'
  import BuyfromFastCheckFrame from '@/components/testorder/buyagreement/BuyfromFastCheckFrame'
  import {formatTimeToStr} from '@/plugin/Date';
  import {createGoodsbarcode} from '@/api/set/jxcgoodsbarcode';
  import {isUGO} from '@/api/login';
  import {auditflow} from '@/api/set/recharge';

  export default {
    name: 'BuyorderDetail',
    data() {
      return {
        isDisable: false,//防止多次提交
        goodsbarcode: '',//商品条码
        storegoodsbarcode: '',//库存商品唯一条码
        flage: true,//数量选择区分显示列
        isprint: false,
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        seedcode: "",
        barcodeList:null,
        batchnoList:null,
        remark: '',
        FastCheck: false,
        showedit:true,
        showtablehead: true,
        yanshoujiel:'验收合格',
        unitguid: '',
        cangkucode: '',
        todoList:[],
        htje: '',
        cangkuname: '',
        roletype: "",
        isupdatechange: false,
        tableData: [
          {column: [], totalnumber: []},
        ],
        tableData1: [],
        isbackorder:false,
        column: [],
        saleorder: {erpserial: '', ht1d: '', returnerpserial: ''},
        isshowqr: false,
        isbuyorder: '',
        controlData: {},
        showtitle1: "none",
        jxcstoreData: [],
        caiGouRukuData: [],//采购入库条码
        goodsbar: {},//商品条形码
        storebarcode: [],//所有库存唯一条码
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        oldTotalNum: 0,//原订单总数量
        scancodes: [],//唯一码
        noscancode: false,//是否需要唯一码扫码
        initContent: [],//导出二维表
        initContentLeft: [],//导出二维表左眼
        initContentRight: [],//导出二维表右眼
        xcolumn: [],
        ycolumn: [],
        status: '',
      }
    },
    methods: {
      inputBatch() {
        this.$refs.ScanCodeBatch.show(this.controlData,this.scancodes,this.isshowqr,this.batchnoList);
      },
      fastCheckIn() {
        if (this.controlData.isdistribute == 80&&!isUGO()) {
          this.$refs.BuyfromFastCheckFrame.show(this.controlData, this.tableData);
        } else {
          this.$refs.BuyfromFastCheck.show(this.controlData.tracknum, this.controlData.pcustomerserial, this.tableData);
        }
      },
      showSupplyOrder() {//显示供应商系统中的订单
        this.$refs.BuyfromList.show(this.controlData.tracknum, this.controlData.pcustomerserial);
      },
      createBarcode(printtype) {
        var number = 0;
        var goodsD=this.controlData.billmap;
        for (let i in goodsD) {
          if(goodsD[i]['产品名称']=='合计')continue;
          number+= parseInt(goodsD[i]['数量']);
        }

        if (number > 0) {
          //获取条码
          this.isDisable=true;
          createGoodsbarcode({number: number}).then(response => {
            if (response.data.code == 0) {
              var codePre = response.data.codepre;
              var num = response.data.num;

              var  bars=[];
              for (let i in goodsD) {
                if(goodsD[i]['产品名称']=='合计')continue;

                var tn = parseInt(goodsD[i]['数量']);
                for (let j = 0; j < tn; j++) {
                  bars.push({
                    "storegoodsbarcode": codePre + this.padleft((num - number + 1).toString(), 3, '0'),
                    "cangkucode": this.controlData.cangkucode,
                    "inordernum":this.controlData.erpserial,
                    "seedcode": goodsD[i]['seedcode'],
                    "packagesize": goodsD[i]['packagesize']
                  });
                  number = number - 1;
                }
              }
              this.barcodeList=bars;
              batchSave({caiGouRukuData: JSON.stringify(bars),erpbarcodes:null}
              ).then(response => {
                this.isDisable=false;
                this.printBarcode(printtype)
              })
            }
          });
        } else {
          this.printBarcode(printtype)
        }
      },
      padleft(ret,width,padChar) {
        while (ret.length < width) {
          ret = padChar + ret;
        }
        return ret;
      },
      //唯一码扫码数量
      scancodeloadBatch(scancodes) {
        this.scancodes = scancodes;
        for (let j = 0; j < scancodes.length; j++) {
          scancodes[j].hasuse=0;
        }
        //bcode是唯一码的数量
        for (let g = 0; g < this.tableData[0]['billmap'].length; g++) {
          var arr = this.tableData[0]['billmap'][g];

          var seedcode = ''
          var packagesize = ''
          var number=0
          for (let j = 0; j < arr.length; j++) {
            if (arr[j].hasOwnProperty('seedcode'))
              seedcode = arr[j]['seedcode'];
            if (arr[j].hasOwnProperty('packagesize'))
              packagesize = arr[j]['packagesize'];
            if (arr[j].hasOwnProperty('数量'))
              number = arr[j]['数量']
          }
          var num = 0;
          for (let j = 0; j < scancodes.length; j++) {
            if (scancodes[j].seedcode == seedcode && scancodes[j].packagesize == packagesize&&scancodes[j].hasuse==0) {
              num += scancodes[j].totalnumber;
              scancodes[j].hasuse = 1;
              if (number == num)
                break;
            }
          }
          for (let j = 0; j < arr.length; j++) {
            if (arr[j].hasOwnProperty('bcode'))
              arr[j]['bcode'] = num;
          }
        }
      },
      //商品条码
      selectbarcode(val) {
        this.storegoodsbarcode = ''
        var form = {
          barcode: val
        }
        bardetail(form).then(response => {
          this.goodsbar = response.data.obj
          if (this.goodsbar == undefined) {
            this.$message({
              message: '条码无效',
              type: 'error'
            })
            this.isDisable = false
            this.goodsbarcode = ''
            return
          }
          if (this.goodsbar != undefined && this.goodsbar.noscancode == 1) {
            this.$message({
              type: 'warning',
              message: '此商品请扫唯一码'
            })
            this.goodsbarcode = ''
            return
          }
          //商品条码
          this.goodsbar.goodsbarcode = this.goodsbar.barcode
          //仓库编码
          this.goodsbar.cangkucode = this.controlData.cangkucode
          //采购单编码
          this.goodsbar.buyordernum = this.controlData.erpserial
          // this.$refs.storegoodsbarcode.focus()
          this.stockbarcode()
        })
      },
      getMapValue(ol, col) {
        var ret = '';
        for (let j = 0; j < ol.length; j++) {
          if (ol[j].hasOwnProperty(col))
            ret = ol[j][col];
        }
        return ret;
      },
      //库存商品唯一条码
      stockbarcode(val) {
        //所有库存商品唯一编码
        this.storebarcode.push(val)
        //更新billmap（ 产品明细）
        if (this.tableData.length > 0) {
          var seedname = '';//商品名称
          var packagesize = '';//商品光度
          var count = 0//判断是否已达上限
          var compare = false//判断是否存在商品码
          for (let g = 0; g < this.tableData.length; g++) {
            this.tableData[g]['billmap'] = this.tableData[g]['billmap'].map(o1 => {
              var X = '';
              var Y = '';
              var seedcode = '';
              seedcode = this.getMapValue(o1, 'seedcode');
              Y = this.getMapValue(o1, '球镜');
              X = this.getMapValue(o1, '柱镜');
              if (this.goodsbar.filltemplate == 40) {
                if (seedcode == this.goodsbar.seedcode) {
                  //判断商品数量大于扫描数量加1,否则继续向下循环
                  compare = true
                  if (o1[o1.length - 1]['bcode'] > 0) {
                    //判断商品数量大于扫描数量加1,否则继续向下循环
                    if (this.getMapValue(o1, '数量') > o1[o1.length - 1]['bcode']) {
                      ++count;
                      o1[o1.length - 1]['bcode'] = ++o1[o1.length - 1]['bcode']
                      //库存商品唯一编码
                      this.goodsbar.storegoodsbarcode = val
                      this.goodsbar.status = this.controlData.status
                    }
                  } else {
                    o1[o1.length - 1]['bcode'] = 1
                    ++count;
                    //库存商品唯一编码
                    this.goodsbar.storegoodsbarcode = val
                    this.goodsbar.status = this.controlData.status
                  }
                }
              } else {
                //商品编码、光度一样需要一样
                if (seedcode == this.goodsbar.seedcode && Number(X) == Number(JSON.parse(this.goodsbar.packagesize).X) && Number(Y) == Number(JSON.parse(this.goodsbar.packagesize).Y)) {
                  //判断商品数量大于扫描数量加1,否则继续向下循环
                  compare = true
                  if (this.goodsbar.filltemplate == 20 || this.goodsbar.filltemplate == 30) {
                    packagesize = "{球镜：" + JSON.parse(this.goodsbar.packagesize).Y + ",柱镜：" + JSON.parse(this.goodsbar.packagesize).X + ",type:" + JSON.parse(this.goodsbar.packagesize).type + "}"
                    seedname = this.getMapValue(o1, '产品名称')
                  } else {
                    packagesize = "{球镜：" + JSON.parse(this.goodsbar.packagesize).Y + ",柱镜：" + JSON.parse(this.goodsbar.packagesize).X + "}"
                    seedname = this.getMapValue(o1, '产品名称')
                  }
                  //判断是否已扫描
                  if (o1[o1.length - 1]['bcode'] > 0) {
                    //判断商品数量大于扫描数量加1,否则继续向下循环
                    if (this.getMapValue(o1, '数量') > o1[o1.length - 1]['bcode']) {
                      ++count;
                      o1[o1.length - 1]['bcode'] = ++o1[o1.length - 1]['bcode']
                      //库存商品唯一编码
                      this.goodsbar.storegoodsbarcode = val
                      this.goodsbar.status = this.controlData.status
                      //将数据添加到采购入库数组中
                      this.caiGouRukuData.push(this.goodsbar)
                    }
                  } else {
                    // this.$set(o1, o1.length, {'bcode': 1})
                    o1[o1.length - 1]['bcode'] = 1
                    ++count;
                    //库存商品唯一编码
                    this.goodsbar.storegoodsbarcode = val
                    this.goodsbar.status = this.controlData.status
                    //将数据添加到采购入库数组中
                    this.caiGouRukuData.push(this.goodsbar)
                  }


                }
              }
              return o1;
            })
          }
          //商品光度 不存在提示
          if (!compare) {
            this.$alert('商品光度不存在', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: `请重新扫码!`
                });
              }
            });
            this.goodsbarcode = ''
            return
          }
          //该商品已达上限提示
          if (count == 0) {
            this.$alert('该' + seedname + packagesize + '已达到上限', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: `请继续扫码!`
                });
              }
            });
            this.goodsbarcode = ''
            return
          }
        }
        this.goodsbarcode = ''
      }
      ,
      //导入
      productimport() {
        this.$refs.fileupload.value = ""
        this.$refs.fileupload.click()
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              var seedcodes = []
              var codes = []
              data.forEach((item) => {
                if (item['编码']) {
                  seedcodes.push(item['编码'])
                  codes.push(item['唯一码'])
                } else {
                  data.splice(data.indexOf(item), 1)
                }
              })

              //去重
              if (seedcodes.length > 0) {
                seedcodes = Array.from(new Set(seedcodes))
              }

              //去重后的唯一码数组对比原数据数组数量相同就是没有唯一码重复的
              if (codes.length > 0) {
                if (Array.from(new Set(codes)).length != data.length) {
                  this.$message({
                    message: '唯一码有重复的！',
                    type: 'warning'
                  })
                  return
                }
              }
              for (let i in seedcodes) {
                var scancodes = []
                var totalnumber = 0
                data.forEach((item) => {
                  if (seedcodes[i] == item['编码']) {
                    totalnumber++
                    let obj = {}
                    obj.seedcode = item['编码']
                    obj.seedname = item['名称']
                    obj.cangkucode = this.controlData.cangkucode
                    obj.erpserial = this.controlData.erpserial
                    obj.totalnumber = 1
                    obj.goodsbarcode = item['唯一码']
                    scancodes.push(obj)
                  }
                })
                this.scancodeedit(scancodes, totalnumber)
              }
            }
          })

        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      //查看退货
      lookTuihuo() {
        this.controlData.parenterpserial = this.saleorder.returnerpserial;
        this.$refs.StorageBadDetail.initData(this.controlData)
      }
      ,
      //查看处理日志
      handleloglook() {
        this.$refs.HandlelogList.show()
        this.$refs.HandlelogList.initData(this.erpserial);
      }
      ,
      //处理日志
      handlelog() {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1
        handlelog.casestepname = '仓库已收货'
        handlelog.remark = this.controlData.cangkuname + '已收货'
        saveData(handlelog).then(response => {
        })
      }
      ,
      getTitle() {
        let result = "";
        let temp = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
        if (temp) {
          result += (temp.independentserial ? temp.independentfdname : temp.tenantname)
        }
        if(this.$route.query.bimanage) {
          result = this.controlData.cangkuname?this.controlData.cangkuname.replace('仓库',''):'';
        }
        if (this.isbackorder) {
          result += "【退货单】"
        } else {
          result += "【采购单】"
        }
        return result
      }
      ,
      lookDetails() {
        switch (this.saleorder.erpserial.substring(0, 2)) {
          case "78":
            this.$refs.BaoSunDetail.show(this.saleorder.erpserial);
            break;
          case "79":
            this.$refs.StorageBadOut.show(this.saleorder.erpserial);
            break;
          default:
            let row = {
              erpserial: this.saleorder.erpserial
            }
            this.$refs.DataContactEdit.initData(row)
            this.$refs.DataContactEdit.show()
            break;
        }
      }
      ,
      getLiuYan(remark) {
        return getRemark(remark);
      }
      ,

      close() {
        //当采购单发送修改的时候需要刷新主页面
        if (this.isupdatechange) {
          this.$emit('bindGrid');
        }
        this.dialogSeeVisible = false;
      }
      ,

      print1() {
        // window.print()
        this.showtitle1 = ""
        this.isprint = true
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.isprint = false
          this.showtitle1 = "none"
        })
      }
      ,
      exportExcel(title) {
        var dataexcel = {
          tableData: JSON.stringify(this.tableData),
          controlData: JSON.stringify(this.controlData),
          businessType: 'buyerorder'
        }
        exportExcel(dataexcel)
      },
      exportExceltable(val) {
        this.initContentLeft=[];
        this.initContentRight=[];
        this.initContent=[];
        var seedcode = ''
        var seedname = ''
        var RL = ''
        var columns = this.tableData[0]['column']
        for (let i in columns) {
          if (columns[i] == 'R/L') {
            RL = 'R/L'
          }
        }
        var billmap = this.tableData[0]['billmap']
        for (let i in  billmap) {
          if ((billmap.length - 1) == i) {
            break
          }
          if (RL) {
            var type = billmap[i][1]['R/L']
            var objtype = {X: '', Y: '', P: '', type: type}
            for (let j in billmap[i]) {
              if (billmap[i][j]['球镜']) {
                objtype.Y = billmap[i][j]['球镜']
              } else if (billmap[i][j]['柱镜']) {
                objtype.X = billmap[i][j]['柱镜']
              } else if (billmap[i][j]['数量']) {
                objtype.P = billmap[i][j]['数量']
              } else if (billmap[i][j]['seedcode']) {
                seedcode = billmap[i][j]['seedcode']
              } else if (billmap[i][j]['产品名称'] && billmap[i][j]['产品名称'] != '合计') {
                seedname = billmap[i][j]['产品名称']
              }
            }
            if (type == 'L') {
              this.initContentLeft.push(objtype)
            } else if (type == 'R') {
              this.initContentRight.push(objtype)
            }
          } else {
            var obj = {X: '', Y: '', P: ''}
            for (let j in billmap[i]) {
              if (billmap[i][j]['球镜']) {
                obj.Y = billmap[i][j]['球镜']
              } else if (billmap[i][j]['柱镜']) {
                obj.X = billmap[i][j]['柱镜']
              } else if (billmap[i][j]['数量']) {
                obj.P = billmap[i][j]['数量']
              } else if (billmap[i][j]['seedcode']) {
                seedcode = billmap[i][j]['seedcode']
              } else if (billmap[i][j]['产品名称']) {
                seedname = billmap[i][j]['产品名称']
              }
            }
            this.initContent.push(obj)
          }
        }
        this.xcolumn = []
        this.ycolumn = []
        var content = this.initContent
        if (this.initContent.length > 0) {
          content.forEach(o => {
            let temp1 = this.xcolumn.filter(item => {
              return item == o.X
            })
            if (temp1.length == 0) {
              this.xcolumn.push(o.X)
            }
            let temp2 = this.ycolumn.filter(item => {
              return item == o.Y
            })
            if (temp2.length == 0) {
              this.ycolumn.push(o.Y)
            }
          })
        }
        this.xcolumn.sort((a, b) => {
          return parseFloat(b) - parseFloat(a)
        })
        this.xcolumn.unshift('球\\柱')
        this.xcolumn.push("合计")
        this.ycolumn.sort((a, b) => {
          return parseFloat(b) - parseFloat(a)
        })
        //下面按照格式拼接
        let data = [] //导出的数据,
        this.ycolumn.forEach(y => {
          let heji = 0;
          let temp1 = {}
          temp1["球\\柱"] = y
          this.xcolumn.forEach(x => {
            for (let i in content) {
              if (content[i].X == x && content[i].Y == y) {
                temp1[x] = content[i].P
                if (Number(content[i].P))
                  heji += content[i].P
                break;
              }
            }
          })
          temp1['合计'] = heji
          data.push(temp1)
        })
        //导出合计计算
        var hj = {"球\\柱": "合计"}
        var zhj = 0;
        this.xcolumn.forEach(x => {
          if (x != "球\\柱" && x != "合计") {
            hj[x] = 0
            data.forEach(item => {
              if (Number(item[x])) {
                hj[x] = hj[x] + item[x]
              }
            })
            zhj += hj[x]
          }
          //计算总合计
          if (x == "合计") {
            hj[x] = zhj
          }
        })
        data.push(hj)
        let title = this.controlData.erpserial + " " + "【" + seedcode + "】" + seedname + "【" + new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "】"

        var biaoti = []
        let header1 = this.xcolumn.map(item => parseFloat(item) > 0 ? "+" + item : item)
        biaoti.push("订单号：")
        biaoti.push(this.controlData.erpserial)
        biaoti.push("GY.NO：")
        biaoti.push(this.controlData.tracknum)
        biaoti.push(seedcode)
        biaoti.push(seedname)
        biaoti.push(formatTimeToStr(new Date()))

        if (RL) {
          var dataexcel = {
            initContentLeft: JSON.stringify(this.initContentLeft),
            initContentRight: JSON.stringify(this.initContentRight),
            seedcode: seedcode,
            seedname: seedname,
            businessType: 'inventoryDetails'
          }
          exportExcel(dataexcel,title)
        } else {
          this.$exportExcel(header1, this.xcolumn, data, title, biaoti)
        }

      },
      show() {
        this.isDisable = false;
        this.dialogSeeVisible = true;
      }
      ,
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      }
      ,
      printBarcode(printtype){
        barcodePrint(null, this.controlData.erpserial,printtype);
      },
      showDetail(item, isupdate, tabledata) {
        if (isupdate == 0) {
          getDetail({seedcode: item[0].seedcode}).then(response => {
            var tableData = response.data.obj
            var scancodes = []
            this.$refs.seeddetail.show()
            this.$refs.seeddetail.initData(this.controlData.unitguid, item[0].seedcode, item[1].产品名称, isupdate, "", tabledata, this.isshowqr)
          })
        } else {
          //修改商品
          this.$refs.seeddetail.show()
          var seedcode = item[0].seedcode
          if (this.controlData.isdistribute == 80) {
            seedcode = ''
          }
          this.$refs.seeddetail.initData(this.controlData.unitguid, seedcode, item[1].产品名称, isupdate, "", tabledata, this.isshowqr)
        }
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      }
      ,
      afterCheckIn() {
        this.initData({unitguid: this.controlData.unitguid}, 1);
        this.$emit('bindGrid');
        if (isUGO())
          this.dialogSeeVisible = false;
      },
      update() {//确认入库
        // if (this.controlData.invoicesource == 1) {
        //   this.$message({
        //     message: '未审核的采购订单！',
        //     type: 'warning'
        //   })
        //   return
        // }
        if(isUGO()&&!this.tracknum){
          this.$message({message: '供应商单号必填！', type: 'error'})
          return
        }

        if(this.tableData[0].billmap.length==0){
          this.$message({message: '缺少商品明细！', type: 'error'})
          return
        }
        var batchno=null;
        if (this.batchnoList) {
          if (this.scancodes.length == 0) {
            this.$message({message: '请先录入批次号！', type: 'warning'})
            return
          }
          batchno=this.scancodes;
        }
        this.isDisable = true
        // if (JSON.parse(localStorage.getItem("hpapi_parames")).other.oddrequired == 'true') {
        //   if (!this.logisticstracknum) {
        //     this.$message({
        //       message: '请输入跟踪单号',
        //       type: 'error'
        //     })
        //     this.isDisable = false
        //     return
        //   }
        // }

        //入库
        updatebuyorder({
          unitguid: this.unitguid,
          tracknum: this.tracknum.trim(),//供应商单号
          logisticstracknum: this.logisticstracknum.trim(),//跟踪单号
          scancodes: JSON.stringify(batchno),
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.handlelog();
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
            this.isDisable = false
          }
          this.dialogSeeVisible = false;
          //刷新列表
          this.$emit('bindGrid');
        });
        //
      }
      ,
      /**
       * 显示采购订单
       * @param row 采购订单的信息
       * @param isbuyorder 是否是采购订单（0是销售订单点击，1和空是采购订单点击）
       * @param isshowconfirm(显示确认采购的按钮)
       * @param roletype
       * @param isupdatechange(显示是否需要采购修改)
       * @param groupguid(点击详情时)
       */
      initData(row, isbuyorder, isshowconfirm, roletype, isupdatechange, groupguid) {
        this.initForm()
        for (let i in row.jxcformdetailDOList) {
          if (row.jxcformdetailDOList[i].filltemplate == "40") {
            this.flage = false;
            break;
          }
        }
        this.status = row.status
        this.erpserial = row.erpserial
        this.unitguid = row.unitguid
        //是否是采购单点击跳转按钮，
        this.isbuyorder = isbuyorder;
        this.roletype = roletype
        if (isupdatechange) {
          this.isupdatechange = true
        } else {
          this.isupdatechange = false
        }

        //显示确认按钮
        if (isshowconfirm && isshowconfirm == 1) {
          this.isshowqr = true
        } else {
          this.isshowqr = false
        }
        if (isbuyorder == 0) {
          this.unitguid = JSON.parse(row.buyinfo).erpserial
        } else {
          this.unitguid = row.unitguid
        }
        printingbuy({
          ugg: JSON.stringify({
            unitguid: this.unitguid,
            unitgroup: 3,
            isbuyorder: isbuyorder,
            groupguid: groupguid,
            erpserial1: row.ordernum,
            filltemplate: row.filltemplate,
          })
        }).then(response => {
          this.saleorder = response.data.obj.saleorder;
          this.controlData = response.data.obj.detail;
          this.barcodeList=response.data.obj.barcode;
          this.batchnoList=response.data.obj.batchno;
          this.tracknum = this.controlData == '' ? '' : this.controlData.tracknum
          this.logisticstracknum = this.controlData == '' ? '' : this.controlData.logisticstracknum
          this.FastCheck = this.controlData.tracknum && this.controlData.tracknum.length >= 14 && this.controlData.tracknum.substr(0, 2) == '42';
          this.tableData = response.data.obj.goodsDetail;
          if(isUGO()){
            this.showBackAudit(this.unitguid);
          }
          //是否需要唯一码扫码
          if (response.data.obj.scancodes) {
            var scancodes = response.data.obj.scancodes
            for (let i in scancodes) {
              if (scancodes[i].noscancode == 1) {
                this.noscancode = true;
                break
              }
            }
          }
          if (this.saleorder.erpserial) {
            this.showtablehead = true
          } else {
            this.showtablehead = false
          }

          this.showedit=true;//!(this.controlData.isdistribute==80);
          this.flage=false;
          if (this.tableData.length > 0) {
            for (let g = 0; g < this.tableData.length; g++) {
              //取出表头
              let temparr = []
              let biaoji = 0
              this.column = []
              for (let i in this.tableData[g]['billmap']) {
                for (let j in this.tableData[g]['billmap'][i]) {
                  if (j == "R/L") {
                    biaoji = 1
                  }
                  if( j == "球镜")
                    this.flage=true;

                  if (j != "seedcode" && j != "R/L" && j != "数量" && j != "说明" && j != "产品名称" && j != "球镜" && j != "柱镜" && j != "轴位" && !this.contains(j, temparr) && j != "销售单号" && j != "本次采购数量" && j != "unitguid" && j != "已采购" && j != "办结日期" && j != "单价" && j != "总价") {
                    temparr.push(j)
                  }
                }
              }
              //对表头排序
              this.column.push("seedcode")
              if (biaoji == 1) {
                this.column.push("R/L")
              }
              this.column.push("产品名称")
              if (this.flage) {
                this.column.push("球镜")
                this.column.push("柱镜")
                this.column.push("轴位")
              }
              this.column = this.column.concat(temparr)
              this.column.push("数量")
              this.column.push("bcode")
              this.tableData[g]['column'] = this.column
              this.tableData[g]['billmap'] = this.tableData[g]['billmap'].map(o1 => this.column.map(o2 => {
                if (o2 == '数量' && o1["产品名称"] != '合计') {
                  this.oldTotalNum += o1[o2]
                }
                let ob = {}
                if (o2 == 'bcode') {
                  ob = {bcode: 0}
                } else {
                  ob[o2] = o1[o2]
                }
                return ob
              }))
              this.isbackorder=this.oldTotalNum < 0;
            }
          }
          //公共参数解析
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].parametermap) {
              let biaoji = 0;
              this.$set(this.tableData[i], 'formpropertyData', [])

              for (let j in this.tableData[i].parametermap) {

                if (biaoji % 4 == 0) {
                  let temp = {}
                  temp[j] = this.tableData[i].parametermap[j]
                  this.tableData[i].formpropertyData.push(temp)
                } else {
                  this.tableData[i].formpropertyData[this.tableData[i].formpropertyData.length - 1][j] = this.tableData[i].parametermap[j]
                }
                biaoji++
              }
            }
          }
        });

      }
      ,
      //调整订单数量，将原采购单数量修改成扫码确认的数量
      adjust() {
        var newNum = 0
        var message = ''
        var billmapList = this.tableData[0].billmap
        for (let i = 0; i < billmapList.length; i++) {
          var number = billmapList[i][billmapList[i].length - 1]['bcode'] == undefined ? 0 : billmapList[i][billmapList[i].length - 1]['bcode']
          newNum += number
        }
        message = '原订单' + this.oldTotalNum + '片,将调整到' + newNum + '片'
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          adjustNumber({
            erpserial: this.tableData[0].erpserial,
            billmap: JSON.stringify(this.tableData[0].billmap),
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '调整成功',
                type: 'success'
              })
              //刷新调整后的数量
              for (let g = 0; g < this.tableData.length; g++) {
                this.tableData[g]['billmap'].map(o1 => {
                  o1[o1.length - 4]['数量'] = o1[o1.length - 1]['bcode']
                })
              }
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            duration: 1500,
            message: '已取消'
          });
        });

      } ,
      showBackAudit(groupguid) {//审批记录
        this.todoList = [];
        auditflow({casefvid: groupguid, stepname: 'buyorder'}).then(response => {
          if (response.data.code == 0) {
            // for (let i in response.data.todo) {
            //   this.hastodo=true;
            //   this.todoList.push(response.data.todo[i]);
            // }
            for (let i in response.data.hasdo) {
              this.todoList.push(response.data.hasdo[i]);
            }
          }
        });
      },
      //初始化参数
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.barcodeList=null;
        this.batchnoList=null;
        this.showedit=true
        this.FastCheck = false
        this.oldTotalNum = 0
        this.isDisable = false//防止多次提交
        this.storebarcode = []
        this.goodsbarcode = ''//商品条码
        this.storegoodsbarcode = ''//库存商品唯一条码
        this.goodsbar = {}
        this.caiGouRukuData = []
        this.seedcode = ""
        this.groupguid = ""
        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.cangkucode = ""
        this.cangkuname = ""
        this.erpserial = ""
        this.flage = true
        this.scancodes = []
        this.noscancode = false
      }
    }
    ,
    mounted() {
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
      })
    }
    ,

    components: {
      BuyOrderEditSeedDetail,
      HandlelogList,
      StorageBadDetail,
      BaoSunDetail,
      StorageBadOut,
      CstagreementEdit,
      ScanCodeBatch,
      BuyfromList,
      BuyfromFastCheck,
      BuyfromFastCheckFrame
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyorderDetail.vue